import React, { FormEvent, useCallback, useState } from "react";
import { useFilter } from "./FilterProvider.js";
import { Form } from "../../../packages/ui/form/Form.js";
import { FormRow } from "../../../packages/ui/form/FormRow.js";
import { Select } from "../../../packages/ui/form/select/Select.js";
import { Input } from "../../../packages/ui/form/Input.js";
import { YEAR_OPTIONS } from "./YearSelectorOptions.js";
import { MONTH_STAR_OPTIONS } from "./MonthStarSelectorOptions.js";
import { validateMonthStar } from "../../model/accounting/date/validateMonthStar.js";

/**
 * Renders the main filter/search form.
 */
export const FilterForm = () => {
  const { year, month, titleSearch, setPeriod, setTitleSearch } = useFilter();

  const [title, setTitle] = useState(titleSearch);

  const handleYearChange = useCallback(
    (value: string) => {
      setPeriod(value, "*");
    },
    [setPeriod]
  );

  const handleMonthChange = useCallback(
    (value: string) => {
      setPeriod(year, validateMonthStar(value));
    },
    [setPeriod, year]
  );

  const handleSubmit = useCallback(
    (event: FormEvent) => {
      event.preventDefault();
      setTitleSearch(title);
    },
    [setTitleSearch, title]
  );

  return (
    <div className="period-form">
      <Form onSubmit={handleSubmit} gap="small">
        <FormRow columns={1}>
          <Select value={year} options={YEAR_OPTIONS} onChange={handleYearChange} />
        </FormRow>
        <FormRow columns={1}>
          <Select value={month} options={MONTH_STAR_OPTIONS} onChange={handleMonthChange} />
        </FormRow>
        <FormRow columns={1}>
          <Input type="text" value={title} onChange={setTitle} placeholder="Title search" />
        </FormRow>
      </Form>
    </div>
  );
};
